import { generateUniqueId, stripTimestampAndExtension } from '@/assets/js/Utilities';
import { readAndCompressImage } from "browser-image-resizer";
import Cookies from "js-cookie";
import $ from "jquery";


export default class AdvancedColourMatchV2 {
    constructor() {
        this.blockName = 'advanced-colour-match-v2';
        this.worker = null;
        this.quality = 1;
        this.maxWidth = 512;
        this.maxHeight = 512;

        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };

        this.defaultPreset = {
            ColorSpace: 1,
            CrossCovarianceLimit: 0,
            ReshapingIterations: 0,
            PercentSaturationShift: 100,
            PercentShadingShift: 100,
            ExtraShading: false,
            ScaleRatherThanClip: false,
            PercentTint: 100,
            PercentModified: 100,
        }
    }

    async addBlock(blockNum = lutify.blocks.length, selectedSampleFile = false) {
        UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
        let element = UI.getAdjustmentBlock(blockNum);

        await this.initWorker();
        this.addRegenerateButton($(element));

        $(element).find(".range_slider").on("input", e => {
            blocks.checkSwitchHandler($(element));
            this.sliderHandler(e);
        });

        $(element).find(".range_value").on("change", e => {
            blocks.checkSwitchHandler($(element));
            this.sliderHandler(e);
        });

        $(element).find(".btn-reset-block").on("click", e => this.resetBlock($(element)));

        $(element).find('#apply-colour-match').on('click', () => {
            if (!lutify.getActiveBlock().sampleFile) {
                vm.$root.projectTree.openAdvancedColourMatchV2Modal(vm.$store.state.Projects.currentFile, 'applyColourMatch');
            } else this.apply();
        })

        $(element).find('.sample-selector').on('click', e => {
            vm.$root.projectTree.openAdvancedColourMatchV2Modal(vm.$store.state.Projects.currentFile, 'updateColourMatchSample');
        });


        $(element).find(".opacity_slider").on("input", e => this.opacitySliderHandler($(element), e));
        $(element).find(".opacity-input").on("change", e => this.opacityInputHandler($(element), e));

        UI.initKnob(element, {
            size: 30,
        });

        blocks.add({
            name: "AdvancedColourMatchV2",
            passes: [this.addPass()],
            predictions: [],
            predictionsContent: [],
            blockNum,
            blendingMode: 0,
            blendingModeName: "Normal",
            sampleFile: null,
            targetPixels: null,
            samplePixels: null,
            opacity: 100,
            isVideo: vm.$store.state.UI.video.isLoaded,
            sampleVideoTime: vm.$store.state.UI.video.currentTimeMs,
            values: { ...this.defaultPreset }
        });

        $(element).find(".lut-selector__items-container").hide();
        $(element).find(".expand_options").trigger("click", [false]);

        if (!vm.$store.state.UI.showAddMatchTooltip && vm.$store.getters['Projects/allMatches'].length == 0) {
            vm.$store.dispatch('UI/setAddMatchTooltip', "Please load a reference image first, then save it as a Match using the option above to start using the Colour Match tool");
        }

        if (!Cookies.get("ColourMatchToolNotice")) {
            UI.hideModal();
            UI.showModal(UI.modals.blocks.warnings.colourMatchTool);
        }
    }

    async initWorker() {
        if (this.worker) return;
        this.worker = new Worker("/assets/vendor/colourMatch/CTworker.1.5.js?v=1.0.1");
        await new Promise(resolve => {
            this.worker.addEventListener('message', e => {
                resolve();
            });
        })
    }

    addRegenerateButton($element) {
        let icon = document.createElement('i')
        icon.setAttribute('class', 'btn-block-regenerate material-icons')
        icon.setAttribute('data-tippy-content', 'Regenerate')
        icon.innerHTML = 'loop'
        icon.addEventListener('click', async () => {
            UI.appendBlockLoadingSpinner($element)

            await this.apply();

            UI.removeBlockLoadingSpinner($element)
        })
        $element.find('.header-container .controls-wrapper').prepend(icon)
    }

    opacitySliderHandler($element, e) {
        let opacityValue = e.currentTarget.value;
        let calcOpacityValue = opacityValue * 0.01;

        $element.find(".opacity-input").val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

        gpu.render();
    }

    opacityInputHandler($element, e) {
        let opacityValue = e.currentTarget.value;
        let opacitySlider = $element.find(".opacity_slider");

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger("input");
    }

    async setTargetPixels() {
        let blockNum = blocks.getBlockIndex_byBlockNum(lutify.getActiveBlock().blockNum);
        let passes = blocks.getAllPassesToBlock(blockNum);
        let targetImg = lutify.getIDTLMTimage(passes);

        let compressedImage = await readAndCompressImage(
            loader.dataURLtoFile(targetImg, `target.jpg`),
            {
                quality: this.quality,
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight,
            }
        );

        let compressedImageURL = URL.createObjectURL(compressedImage)
        lutify.getActiveBlock().targetPixels = await this.getPixels(compressedImageURL);
        URL.revokeObjectURL(compressedImageURL);
    }

    async apply(predict = true) {
        try {
            vm.$store.dispatch('App/setBlockLoading', true);
            $('#blocks-container--outer').addClass('--overlay');
            $('#project-navigator-container').addClass('--overlay');
            $('#filmstrip-container .thumbnail-container').addClass('--overlay');

            vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
            UI.appendBlockLoadingSpinner($(UI.getActiveBlock()));

            if (lutify.getActiveBlock().isVideo) {
                lutify.getActiveBlock().sampleVideoTime = vm.$store.state.UI.video.currentTimeMs;
            }

            await this.setTargetPixels();

            if (predict) {
                const { predictions, predictionsContent } = await this.createPredictions();
                lutify.getActiveBlock().predictions = [...predictions];
                lutify.getActiveBlock().predictionsContent = [...predictionsContent];
            }

            const [lut] = await this.loadLutsFromPredictions(lutify.getActiveBlock().predictions)

            const pass = gpu.createLUTPass(lut.texture);
            pass.uid = lutify.getActiveBlock().passes[0].uid;
            let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[0].uid);
            gpu.composer.passes[index] = pass;
            lutify.getActiveBlock().passes[0] = pass;
            gpu.render();

            vm.$store.dispatch("Loader/showProgressBar", false);
            UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));
        } finally {
            vm.$store.dispatch('App/setBlockLoading', false);
            $('#blocks-container--outer').removeClass('--overlay');
            $('#project-navigator-container').removeClass('--overlay');
            $('#filmstrip-container .thumbnail-container').removeClass('--overlay');
            vm.$store.dispatch("Loader/showProgressBar", false);
        }
    }

    async loadLutsFromPredictions(predictions) {
        const loadedLuts = [];

        for await (const [key, prediction] of predictions.entries()) {
            const [lut] = await window.luts.load([prediction]);

            loadedLuts.push(lut);
        }

        return loadedLuts;
    }

    async createPredictions() {
        const { lutFile, lutContent } = await this.predict(lutify.getActiveBlock().values);

        return {
            predictions: [
                lutFile
            ],
            predictionsContent: [
                lutContent
            ]
        }
    }

    predict(values, targetPixels, samplePixels) {
        if (!values) values = lutify.getActiveBlock().values;
        if (!targetPixels) targetPixels = lutify.getActiveBlock().targetPixels;
        if (!samplePixels) samplePixels = lutify.getActiveBlock().samplePixels;

        return new Promise(resolve => {
            this.worker.postMessage([values, targetPixels, samplePixels]);
            this.worker.onmessage = e => {
                const lutContent = new TextDecoder().decode(e.data.lut_copy);
                const lutFile = new File([lutContent], "colour-match.cube", { type: "text/plain" });

                resolve({
                    lutFile,
                    lutContent
                });
            }
        })
    }

    addPass() {
        let pass = gpu.createCopyPass(false);
        gpu.addPassToComposer(pass, "toMiddle");
        return pass;
    }

    sliderHandler(e) {
        let $element = $(e.currentTarget);
        // $(UI.getActiveBlock()).find('.btn-block-needs-update').removeClass('hide');

        let value = parseFloat($element.val());
        let control = $element.data("control");

        if ($element.hasClass("range_value")) {
            if (value > parseInt($element.attr("max"))) {
                value = parseInt($element.attr("max"));
                $element.val(value);
            }
            if (value < parseInt($element.attr("min"))) {
                value = parseInt($element.attr("min"));
                $element.val(value);
            }
        }

        if ($element.hasClass("range_slider")) {
            $element.closest(".block-sliders-container").find(".range_value").val(value);
        } else {
            $element.closest(".block-sliders-container").find(".range_slider").val(value);
        }

        lutify.getActiveBlock().values[control] = value;
    }

    setBlockValues($block, values) {
        lutify.getActiveBlock().values = values;

        Object.keys(values).forEach(key => {
            let control = $block.find(`[data-control="${key}"]`);
            if (!control) return;

            if (control.attr('type') == 'range') {
                control.val(values[key]);
                control.trigger("input");
            } else {
                control.attr('checked', values[key]);
                control.trigger('change');
            }
        });
    }

    async getPixels(targetImage) {
        let img = new Image();
        img.src = targetImage;
        await img.decode();

        let size = lutify.getConstrainedImageSize(img.width, img.height);
        UI.colourMatchCanvas.setSize(size.width, size.height);
        UI.colourMatchCanvas.el.getContext('2d').drawImage(img, 0, 0, size.width, size.height);
        return UI.colourMatchCanvas.el.getContext('2d').getImageData(0, 0, size.width, size.height);
    }

    async setSampleFile(file) {
        lutify.getActiveBlock().passes[0].uid = generateUniqueId();

        blocks.checkSwitchHandler($(UI.getActiveBlock()));

        lutify.getActiveBlock().sampleFile = {
            id: file.id,
            type: file.type,
        };

        let match = vm.$store.getters["Projects/assetById"](file.id, file.type);
        let matchStoreData = await lutify.fetchMatch(match);

        let compressedImage = await readAndCompressImage(
            matchStoreData.imageIDTLMT,
            {
                quality: this.quality,
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight,
            }
        );

        let compressedImageURL = URL.createObjectURL(compressedImage)
        lutify.getActiveBlock().samplePixels = await this.getPixels(compressedImageURL);
        URL.revokeObjectURL(compressedImageURL);

        this.setSampleFileUI(matchStoreData.blob, match.name);

        this.resetOpacity();
    }

    setSampleFileUI(imageBlob, name) {
        if (!lutify.getActiveBlock()) return;
        let block = UI.getActiveBlock();
        let $block = $(block);

        let imgSrc = URL.createObjectURL(imageBlob);
        let imgElement = document.createElement('img');
        imgElement.setAttribute('src', imgSrc);
        imgElement.setAttribute('class', 'thumbnail');
        imgElement.setAttribute('data-tippy-content', 'Click to change a Match');

        $block.find('.sample-selector img').remove();
        $block.find('.sample-selector .select-asset-btn').addClass('hide');
        $block.find('.sample-selector').prepend(imgElement);

        name = stripTimestampAndExtension(name);
        $block.find('.sample-selector .name').text(`Selected Match: ${name}`);
    }

    resetBlock($element) {
        const pass = gpu.createCopyPass(false);
        pass.uid = lutify.getActiveBlock().passes[0].uid;
        let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[0].uid);
        gpu.composer.passes[index] = pass;
        lutify.getActiveBlock().passes[0] = pass;
        gpu.render();

        this.resetOpacity();

        lutify.getActiveBlock().sampleFile = null;
        lutify.getActiveBlock().targetPixels = null;
        lutify.getActiveBlock().samplePixels = null;
        lutify.getActiveBlock().predictions = [];
        lutify.getActiveBlock().predictionsContent = [];

        this.setBlockValues($element, { ...this.defaultPreset })

        this.resetSampleFileUI();

        gpu.render();
    }

    resetOpacity() {
        $(UI.getActiveBlock()).find(".opacity-input").val(100);
        $(UI.getActiveBlock()).find(".opacity-input").trigger("change");
    }

    resetSampleFileUI() {
        if (!lutify.getActiveBlock()) return;
        let $block = UI.getActiveBlock();

        $block.find('.sample-selector img').remove();
        $block.find('.sample-selector .select-asset-btn').removeClass('hide');
        $block.find('.sample-selector .name').text(``);
    }

    async applyChanges($block, values, blockData) {
        if (blockData.sampleFile) {
            if (!vm.$store.getters["Projects/assetById"](blockData.sampleFile.id, blockData.sampleFile.type)) {
                vm.$snackbar('Selected Match for Colour Match is no longer available. Please select a new one or otherwise remove the AI Colour Extract tool.', 'error', {
                    timeout: -1,
                    contentClass: 'text-center',
                });
                return;
            }

            await this.setSampleFile(blockData.sampleFile);

            if (blockData.isVideo) {
                lutify.getActiveBlock().sampleVideoTime = blockData.sampleVideoTime;
                document.querySelector("#video").currentTime = blockData.sampleVideoTime;
                vm.$store.dispatch('UI/setVideoCurrentTime', blockData.sampleVideoTime);

                // wait for video frame to be rendered
                await new Promise(resolve => {
                    setTimeout(() => {
                        resolve();
                    }, 500);
                });
            }

            lutify.getActiveBlock().predictions = blockData.predictionsContent.map(predictionContent => new File([predictionContent], "colour-match.cube", {type: "text/plain"}));
            lutify.getActiveBlock().predictionsContent = blockData.predictionsContent;

            this.setBlockValues($block, blockData.values)

            await this.apply(false);

            $block.find(".opacity-input").val(parseInt(blockData.opacity));
            $block.find(".opacity-input").trigger("change");
            $block.find(".controls-wrapper .switch > input").trigger("click");
            window.lutify.getActiveBlock().collapsedPreviews = blockData.collapsedPreviews;
            if (blockData.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${blockData.blendingMode}"]`).trigger("click");
        }
    }
}
